// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c-button-til-solu {
  padding-top: 0px !important;
  position: relative;
  top: -10px !important;
}

.fasteignasala-mynd {
  float: left;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
  max-height: 200px;
  width: 100%;
  object-fit: contain;
}

.calculator-live-bg {
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 20px !important;
  max-height: 56px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/properties-for-sale-search/properties-for-sale-search.component.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,kBAAA;EACA,qBAAA;AACF;;AAEA;EACE,WAAA;EACA,8DAAA;EACA,iBAAA;EACA,WAAA;EAEA,mBAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;AACF","sourcesContent":[".c-button-til-solu {\r\n  padding-top: 0px !important;\r\n  position: relative;\r\n  top: -10px !important;\r\n}\r\n\r\n.fasteignasala-mynd {\r\n  float: left;\r\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;\r\n  max-height: 200px;\r\n  width: 100%;\r\n  -o-object-fit: contain;\r\n  object-fit: contain;\r\n}\r\n\r\n.calculator-live-bg {\r\n  margin-left: 10px;\r\n  margin-right: 10px;\r\n  margin-top: 20px !important;\r\n  max-height: 56px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
